var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6667 8H9.33333V9.33333H10.6667M10.6667 5.33333H9.33333V6.66667H10.6667M12 10.6667H6.66667V9.33333H8V8H6.66667V6.66667H8V5.33333H6.66667V4H12M5.33333 2.66667H4V1.33333H5.33333M5.33333 5.33333H4V4H5.33333M5.33333 8H4V6.66667H5.33333M5.33333 10.6667H4V9.33333H5.33333M2.66667 2.66667H1.33333V1.33333H2.66667M2.66667 5.33333H1.33333V4H2.66667M2.66667 8H1.33333V6.66667H2.66667M2.66667 10.6667H1.33333V9.33333H2.66667M6.66667 2.66667V0H0V12H13.3333V2.66667H6.66667Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCity);
export default __webpack_public_path__ + "static/media/city.6a51f880cb3f5e84ab519bdb75561e21.svg";
export { ForwardRef as ReactComponent };